import { makeSeparatedStore } from '@autobid/nuxt-pinia-store/utils/makeSeparatedStore'
import { removeReference } from '@autobid/strapi-integration/utils/helpers'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface StartDateRange {
  dateFrom: string
  dateTo: string
}

export interface AuctionFilterState {
  type: string[]
  stage: string[]
  startDateRange: StartDateRange
  appIds: number[]
  descriptionTitles: string[]
  countryIds: number[]
  designations: string[]
  numbers: number[]
}

const INITIAL_AUCTION_FILTER_STATE: AuctionFilterState = {
  type: [],
  stage: [],
  startDateRange: { dateFrom: '', dateTo: '' },
  appIds: [],
  countryIds: [],
  designations: [],
  numbers: [],
  descriptionTitles: [],
}

export const useAuctionStore = makeSeparatedStore((key: string) =>
  defineStore(`auction/${key ?? ''}`, () => {
    const filter = ref(removeReference(INITIAL_AUCTION_FILTER_STATE))
    const isOpen = ref(false)
    const isRendered = ref(false)

    const reset = () => {
      filter.value = removeReference(INITIAL_AUCTION_FILTER_STATE)
    }

    return {
      isRendered,
      filter,
      isOpen,
      reset,
    }
  }),
)
